import Button from '@deliveryhero/pd-cookbook/components/ButtonV2';
import { Link } from '@deliveryhero/pd-cookbook/components/Link';
import { Message } from '@deliveryhero/pd-cookbook/components/Message';
import { TextInput } from '@deliveryhero/pd-cookbook/components/TextInput';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';

import { Form, Formik, FormikHelpers } from 'formik';
import { AppRoute } from 'share/types/routes';

import { IForgotPasswordFormProps } from './types';
import {
  ForgotPasswordFormValidationSchema,
  ForgotPasswordFormValues
} from './validation';

const BUTTON_LABEL = 'Continue';

export const ForgotPasswordForm = ({
  initialValues,
  onSubmit
}: IForgotPasswordFormProps): JSX.Element => {
  const displayErrorAlert = (message: string) => {
    return (
      <Message
        message={message}
        kind="error"
        style={{ marginBottom: '16px' }}
      />
    );
  };

  const handleSubmit = async (
    values: ForgotPasswordFormValues,
    actions: FormikHelpers<ForgotPasswordFormValues>
  ) => {
    await onSubmit(values);
    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={ForgotPasswordFormValidationSchema}
    >
      {({ isSubmitting, errors, touched, handleChange, values }) => (
        <Form
          style={{
            width: '100%',
            textAlign: 'center'
          }}
        >
          {errors.username && displayErrorAlert(errors.username)}
          <TextInput
            id="username"
            name="username"
            style={{ marginBottom: 'md' }}
            label="Work email"
            value={values.username}
            onChange={handleChange}
            invalid={touched.username && errors.username ? true : false}
            isError={touched.username && errors.username ? true : false}
          />
          <Button
            type="submit"
            layout="full-width-primary"
            marginTop="md"
            status={isSubmitting ? 'is-loading' : 'is-idle'}
          >
            {BUTTON_LABEL}
          </Button>
          <Typography type="label-md" marginTop="md">
            <Link href={AppRoute.Login}>Back to login</Link>
          </Typography>
        </Form>
      )}
    </Formik>
  );
};
